import React from 'react';

import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import VideoGallery from '../components/videoGallery/VideoGallery';

const videoLayout = () => {
    return (
        <div>
            <Header />
            <VideoGallery />
            <Footer />
        </div>
    );
};

export default videoLayout;


// WEBPACK FOOTER //
// ./src/pages/videoLayout.js